<script lang="ts" setup>
import CorporateGovernanceMemberHero from '@/domains/investor/corporate-governance/supervisor/components/Hero/Hero.vue'
import CorporateGovernanceMemberLead  from '@/domains/investor/corporate-governance/member/components/Lead/Lead.vue'
import CorporateArticle from '@/domains/investor/components/Article/Article.vue'
import { useFetchMember } from '~/domains/investor/composables/useFetchMember'

definePageMeta({
  layout: 'investor',
})

const { fetchMember } = await useFetchMember()
const response = await fetchMember('komitet-audytu/')
const boardMember = response.data.value

if (!boardMember) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Member not found',
  })
}

const { t } = useI18n()
const route = useRoute()
const config = useRuntimeConfig()

useHead(() => ({
  title: t('pageTitles.investorAuditBoardMember.title', { member: boardMember.boardMemberName }),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorAuditBoardMember.meta', { member: boardMember.boardMemberName }),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${config.public.appURL}${route.fullPath}`,
    },
  ],
}))

</script>

<template>
  <div class="corporateGovernanceMemberPage">
    <CorporateGovernanceMemberHero
      :lead="boardMember.boardMemberLead"
      :title="boardMember.boardMemberName"
    />
    
    <div class="corporateGovernanceMemberPage__container">
      <CorporateGovernanceMemberLead
        :id="$t('investor.corporateGovernance.member.hero.secondCategory.url').replace('#', '')"
        :title="boardMember.boardMemberName"
        :subtitle="boardMember.boardMemberRole"
      />
    
      <CorporateArticle
        v-if="boardMember.boardMemberDescription"
        :content="boardMember.boardMemberDescription"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.corporateGovernanceMemberPage {
  :deep(.ui-header) {
    margin-bottom: 2.4rem;
  }

  :deep(.article) {
    padding-top: 0;
    
    hr {
      display: none;
    }
  }
}
</style>
